import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { useShoppingCartStore } from '@/stores/shoppingCart'

export const useCompletedTransactionStore = defineStore('completedTransaction', () => {
  const completedTransactions = ref([])

  const commitFromCart = () => {
    const shoppingCartStore = useShoppingCartStore()

    completedTransactions.value.push({
      checkoutResponse: { ...shoppingCartStore.checkoutResponse },
      items: shoppingCartStore.getCartItems().map((entry) => ({ ...entry })),
      completedAt: new Date().toISOString(),
    })

    shoppingCartStore.clearCart()
  }

  const getCompletedTransactions = () => completedTransactions.value

  const mostRecent = computed(() => completedTransactions.value.at(-1) ?? null)

  const clear = () => {
    completedTransactions.value = []
  }

  return {
    completedTransactions,
    commitFromCart,
    getCompletedTransactions,
    mostRecent,
    clear,
  }
})
